<nav *ngIf="navigationData$ | async as navigationData" class="mobile">
    <ul>
        <li *ngFor="let navigationEntry of navigationData | slice: 0:MAX_MAIN_ITEMS; let i = index" class="navigation-item">
            <ng-container *ngTemplateOutlet="topNavigationItemMobile; context: { $implicit: navigationEntry, index: i }"></ng-container>

            <div class="dropdown mobile">
                <div class="row">
                    <div class="container navigation-item-sub segment">
                        <div class="close-mobile-menu">
                            <button class="drg-icon drg-icon-error" (click)="resetNavigationSelection(true)"></button>
                        </div>
                        <ul class="reset nav-items">
                            <li
                                class="nav-item nav-expand"
                                *ngFor="
                                    let navigationEntryLevel1 of navigationEntry.Children | slice: 0:MAX_BUSINESSFIELD_ITEMS;
                                    let j = index
                                "
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        inputLabelPairItemCheckbox;
                                        context: {
                                            name: 'siteNavigationSecondLevelSelectedSegment' + i,
                                            id: 'navbar-toggle-segment-' + i + '-level-' + i + '-item-' + j,
                                            value: 'navbartogglesegment' + i + 'level' + i + 'item' + j,
                                            inputClass: 'site-navigation-third-level-selected-segment',
                                            labelClass: 'nav-link nav-expand-link',
                                            label: navigationEntryLevel1.DisplayName,
                                            cookieBusinessField: navigationEntryLevel1.TechnicalName,
                                            isMobile: true
                                        }
                                    "
                                ></ng-container>
                                <ul class="reset nav-items nav-expand-content">
                                    <li class="nav-item">
                                        <ul class="reset">
                                            <li class="nav-item">
                                                <label
                                                    class="nav-link nav-back-link"
                                                    (click)="resetChildren('siteNavigationThirdLevelSelectedSegment' + i)"
                                                    [ngClass]="
                                                        getCssClassByBusinessField(navigationEntryLevel1.TechnicalName.toLowerCase(), 'bg')
                                                    "
                                                    ><span></span>{{ navigationEntryLevel1.DisplayName }}
                                                </label>
                                            </li>
                                        </ul>
                                        <div class="holder">
                                            <div
                                                class="column"
                                                *ngFor="
                                                    let navigationEntryLevel2 of navigationEntryLevel1.Children
                                                        | slice: 0:MAX_BUSINESSFIELD_COLUMNS;
                                                    let k = index
                                                "
                                            >
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        inputLabelPairItemSubCheckbox;
                                                        context: {
                                                            name: 'siteNavigationThirdLevelSelectedSegment' + i,
                                                            id: 'navbar-toggle-segment-' + i + '-level-' + i + '-item-' + j + '-child-' + k,
                                                            value: 'navbartogglesegment' + i + 'level' + i + 'item' + j + 'child' + k,
                                                            inputClass: 'site-navigation-third-level-selected-segment',
                                                            labelClass:
                                                                'headline ' +
                                                                getCssClassByBusinessField(
                                                                    navigationEntryLevel1.TechnicalName.toLowerCase(),
                                                                    'font'
                                                                ),
                                                            label: navigationEntryLevel2.DisplayName,
                                                            cookieBusinessField: navigationEntryLevel1.TechnicalName
                                                        }
                                                    "
                                                ></ng-container>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        dropdownChild;
                                                        context: {
                                                            $implicit: navigationEntryLevel2,
                                                            breadcrumb: [
                                                                navigationEntry.DisplayName,
                                                                navigationEntryLevel1.DisplayName,
                                                                navigationEntryLevel2.DisplayName
                                                            ],
                                                            cookieBusinessField: navigationEntryLevel1.TechnicalName
                                                        }
                                                    "
                                                ></ng-container>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</nav>

<ng-template let-index="index" let-navigationEntry #topNavigationItemMobile>
    <ng-container *ngIf="model$ | async as model">
        <input
            type="radio"
            name="sitenavigationTopSegmentSelected"
            id="navbar-toggle-segment-{{ index }}"
            value="navbartogglesegment{{ index }}"
            [(ngModel)]="model['sitenavigationTopSegmentSelected']"
        />
        <label
            class="dropdown-label-navbar"
            for="navbar-toggle-segment-{{ index }}"
            (click)="resetNavigationSelection(); openMobile(navigationEntry.DisplayName)"
            [ngClass]="getCssClassByBusinessField('draeger', 'underline')"
        >
            {{ navigationEntry.DisplayName }}
        </label>
    </ng-container>
</ng-template>

<ng-template #dropdownChild let-navigationEntryLevel2>
    <div class="dropdown-child">
        <ul class="reset">
            <li *ngFor="let link of navigationEntryLevel2.Children | slice: 0:MAX_LINKS_PER_COLUMN">
                <a da-link [link]="link.ResolvedDisplayUrl">{{ link.DisplayName }}</a>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template
    let-name="name"
    let-id="id"
    let-value="value"
    let-labelClass="labelClass"
    let-inputClass="inputClass"
    let-label="label"
    #inputLabelPairItemSubCheckbox
>
    <ng-container *ngIf="model$ | async as model">
        <input type="checkbox" class="{{ inputClass }}" [checked]="model[name] && model[name] === value" />
        <label class="{{ labelClass }}" (click)="setMobileSubMenu(value, name)">
            {{ label }}
        </label></ng-container
    >
</ng-template>

<ng-template
    let-name="name"
    let-id="id"
    let-value="value"
    let-labelClass="labelClass"
    let-inputClass="inputClass"
    let-label="label"
    let-cookieBusinessField="cookieBusinessField"
    #inputLabelPairItemCheckbox
>
    <ng-container *ngIf="model$ | async as model">
        <input type="radio" [(ngModel)]="model[name]" name="{{ name }}" value="{{ value }}" id="{{ id }}" class="{{ inputClass }}" />
        <label class="{{ labelClass }}" for="{{ id }}" (click)="setMobileSubMenu(value, name)">
            <span [ngClass]="model[name] === value ? getCssClassByBusinessField(cookieBusinessField, 'font') : null"> {{ label }}</span>
        </label>
    </ng-container>
</ng-template>
